export const isStandaloneApp = (): boolean => {
  const subdomain = process.env.Ai_SAAS_SUBDOMAIN;
  const currentHost = window.location.origin;
  return currentHost === subdomain;
};

/** 获取登录后的默认首页路径 */
export const getHomePath = (): string => {
  return isStandaloneApp() ? '/app/mine' : '/org/user';
};

/** 是否通过 .cn 域名访问（用于 ICP 备案号展示） */
export const isChinaDomain = (): boolean => {
  const hostname = window.location.hostname || '';
  return hostname.endsWith('.cn');
};

/** 是否为租户子域名形式（非 IP，且第一段不是 app） */
export const isTenantSubdomain = (): boolean => {
  const hostname = window.location.hostname;
  if (!hostname) return false;
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return false;
  if (hostname.split('.').length === 2 || (hostname.split('.').length === 3 && hostname.split('.')[0] === 'www')) {
    return false;
  }
  const first = hostname.split('.')[0];
  if (!first || first === 'app') return false;
  return true;
};

/** 根据当前域名解析租户编码：
 *  - 取域名第一段作为租户编码
 *  - IP 地址或第一段为 app 时统一返回 demo
 */
export const getTenantCode = (): string => {
  if (!isTenantSubdomain()) return 'demo';
  if (window.location.hostname.split('.')[0] === 'localhost') {
    return 'demo';
  }
  return window.location.hostname.split('.')[0] || 'demo';
};
